export default {
  FETCH_ALL: 'USER_ROLES/FETCH_ALL',
  SET_ALL: 'USER_ROLES/SET_ALL',
  LIMIT: 'USER_ROLES/LIMIT',
}
